

import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { NgWaitModule } from "../../../ng-shared/ng-components/ng-wait/ng-wait.module";

import { DialogModule } from "primeng/primeng";
import {NgBaseSupplementMenuModalComponent} from "../base-supplement-menu-modal/base-supplement-menu-modal.component";
import {NgBaseSupplementMenuComponent} from "./base-supplement-menu.component";
import {BaseSupplementListService} from "../base-supplement-list.service";
// import {TciTenantModule} from "../../ng-tenant/tci-tenant.module";
const COMPONENTS = [
    NgBaseSupplementMenuModalComponent,
    NgBaseSupplementMenuComponent
];
@NgModule({
    imports: [
        CommonModule,
        DialogModule,
        FormsModule,
        NgWaitModule,
        // TciTenantModule
    ],
    declarations: [
        ...COMPONENTS
    ],
    exports: [
        ...COMPONENTS
    ],
    providers: [
        BaseSupplementListService
    ]
})
export class NgBaseSupplementMenuModule {
}
